export default "__VITE_ASSET__kVkMWttZ__"